import { registerPlugin } from '@capacitor/core';

const CashfreePaymentBridge = registerPlugin('CashfreePaymentPlugin');

export default CashfreePaymentBridge;